import { render, staticRenderFns } from "./MapCard.vue?vue&type=template&id=24428986&scoped=true"
import script from "./MapCard.vue?vue&type=script&lang=js"
export * from "./MapCard.vue?vue&type=script&lang=js"
import style0 from "./MapCard.vue?vue&type=style&index=0&id=24428986&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24428986",
  null
  
)

export default component.exports